(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize() {
    document.querySelectorAll('[data-pk-swipe-track], .jdgm-carousel__item-container').forEach(track => {
      if (track.dataset.swipeReady) return;
      const slides = Array.from(track.children).filter(slide => slide.matches('.mascot-story, .quote-card, .jdgm-carousel-item'));
      if (slides.length < 2) return;
      track.dataset.swipeReady = 'true';
      if (track.matches('.jdgm-carousel__item-container')) track.classList.add('pk-native-review-track');
      const controls = document.createElement('div');
      controls.className = 'pk-swipe-controls';
      const buttons = slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', (track.dataset.swipeLabel || slide.querySelector('h3, strong, .jdgm-carousel-item__reviewer-name')?.textContent?.trim() || String(index + 1)).replace('__number__', String(index + 1)));
        button.setAttribute('aria-pressed', String(index === 0));
        const dot = document.createElement('span');
        dot.className = 'pk-swipe-dot';
        dot.setAttribute('aria-hidden', 'true');
        button.append(dot);
        button.addEventListener('click', () => {
          track.scrollTo({left: track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: reduced.matches ? 'auto' : 'smooth'});
        });
        controls.append(button);
        return button;
      });
      track.after(controls);
      let frame = false;
      const update = () => {
        frame = false;
        const left = track.getBoundingClientRect().left;
        const active = slides.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[best].getBoundingClientRect().left - left) ? i : best, 0);
        buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
      };
      track.addEventListener('scroll', () => { if (!frame) { frame = true; requestAnimationFrame(update); } }, {passive:true});
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  let queued = false;
  const observer = new MutationObserver(records => {
    if (!records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('.jdgm-carousel__item-container, .jdgm-carousel-item') || node.querySelector?.('.jdgm-carousel__item-container'))))) return;
    if (!queued) { queued = true; requestAnimationFrame(() => {queued = false; initialize();}); }
  });
  observer.observe(document.documentElement, {childList:true,subtree:true});
})();
